import api from 'general/js/api/email-capturing-api';
import $ from 'jquery';
import 'jquery-serializejson';
import get from 'lodash/get';
import pageSpinner from 'general/js/page-spinner';
import GTM from 'general/js/gtm';
import FormComponent from '../../form/js/form.component';

export default class EmailCaptureFormComponent extends FormComponent {
    constructor(el, id, options) {
        super(el, id, options);
        this.action = options.action;
        this._transformData = options.transformData;
        this._onBeforeSubmit = options.onBeforeSubmit;
        this._onSuccessCallback = options.onSuccess;
        this._onErrorCallback = options.onError;
        this._showSpinner = get(options, 'showSpinner', false);
    }

    onSubmit() {
        if (!this.isSubmiting) {
            this.isSubmiting = true;
            this.showSpinner();

            const data = this.getData();
            data.agreeToMarketing = !data.agreeToMarketing;

            if (this._onBeforeSubmit) {
                this._onBeforeSubmit(data);
            }

            try {
                api({
                    method: 'post',
                    url: this.getUrl(),
                    data
                }).then((response) => {
                    this.isSubmiting = false;
                    this.hideSpinner();
                    this.onSuccess(response);
                }, (error) => {
                    this.isSubmiting = false;
                    this.hideSpinner();
                    this.onError(error);
                });
            } catch (err) {
                // call callback instead of error handling for particular form
                // because this is not request error
                this.isSubmiting = false;
                this._onErrorCallback(err);
            }
        }
        // prevent default form submit
        return false;
    }

    showSpinner() {
        if (this._showSpinner) {
            pageSpinner.show();
        }
    }

    hideSpinner() {
        if (this._showSpinner) {
            pageSpinner.hide();
        }
    }

    onSuccess(response) {
        this._onSuccessCallback(response);
    }

    onError() {
        throw new Error('onError should be defined');
    }

    sendFormFieldTracking(e) {
        const target = e.target;
        if (this.refs.trackFields && this.refs.trackFields.indexOf(target) !== -1) {
            const label = this.getAttribute(target, 'track-label');
            if (label) {
                GTM.push(this.getTrackCategory(), 'Field Entry', label);
            }
        }
    }

    getData() {
        const formData = $(this.element).serializeJSON({
            checkboxUncheckedValue: 'false',
            parseBooleans: true,
            useIntKeysAsArrayIndex: true
        });

        return this.getTransformedData(formData);
    }

    getTransformedData(data) {
        if (this._transformData) {
            return this._transformData(data);
        }

        return data;
    }
}
